import { createSlice } from "@reduxjs/toolkit";

const viewSlice = createSlice({
  name: "view",
  initialState: "grid",
  reducers: {
    setCurrentView: (state, action) => action.payload,
  },
});

// Extract the action creators object and the reducer
const { actions, reducer } = viewSlice;

// Extract and export each action creator by name
export const { setCurrentView } = actions;

// Export the reducer, either as a default or named export
export default reducer;
